(() => {
    const policy = document.querySelector('.shopify-policy__container');
    const title = policy?.querySelector('.shopify-policy__title');
    const body = policy?.querySelector('.shopify-policy__body');
    const content = body?.querySelector('.rte');

    if (!title || !body || !content || body.querySelector('.oaks-policy-summary')) return;

    const heading = title.querySelector('h1');
    if (heading) heading.textContent = 'Return Policy';

    const eligibility = content.querySelector('p:nth-child(2)');
    const exceptions = content.querySelector('p:nth-child(13)');

    if (eligibility && !eligibility.textContent.includes('worn to try on is fine')) {
        eligibility.textContent = `${eligibility.textContent.trim().replace(/\.$/, '')} (worn to try on is fine).`;
    }

    if (exceptions) {
        exceptions.textContent = 'Gift cards are final sale and cannot be returned.';
    }

    const windowBadge = document.createElement('div');
    windowBadge.className = 'oaks-policy-window';
    windowBadge.setAttribute('aria-label', '30-day return window');

    const windowParts = [
        ['oaks-policy-window__number', '30'],
        ['oaks-policy-window__unit', 'Days'],
        ['oaks-policy-window__label', 'Returns']
    ];

    windowParts.forEach(([className, text]) => {
        const span = document.createElement('span');
        span.className = className;
        span.textContent = text;
        windowBadge.append(span);
    });

    title.append(windowBadge);

    const summary = document.createElement('aside');
    summary.className = 'oaks-policy-summary';
    summary.setAttribute('aria-labelledby', 'oaks-policy-summary-title');

    const summaryTitle = document.createElement('h2');
    summaryTitle.id = 'oaks-policy-summary-title';
    summaryTitle.className = 'oaks-policy-summary__title';
    summaryTitle.textContent = 'Policy summary';
    summary.append(summaryTitle);

    const list = document.createElement('dl');
    const items = [
        ['Return window', '30 days from delivery'],
        ['Condition', 'Unworn and unused, with original tags and proof of purchase (worn to try on is fine)'],
        ['Vintage + secondhand', 'May show age or wear. Review the listing and measurements before purchasing'],
        ['Return shipping', 'Paid by the customer for approved returns. Oaks covers damaged, incorrect, or materially different items'],
        ['Authorization required', 'Email before sending anything back'],
        ['Final sale', 'Gift cards only']
    ];

    items.forEach(([term, description]) => {
        const item = document.createElement('div');
        item.className = 'oaks-policy-summary__item';

        const dt = document.createElement('dt');
        dt.textContent = term;

        const dd = document.createElement('dd');
        dd.textContent = description;

        item.append(dt, dd);
        list.append(item);
    });

    summary.append(list);
    body.insertBefore(summary, content);
})();
